import { render, staticRenderFns } from "./FAreaTable.vue?vue&type=template&id=1c03461b&scoped=true"
import script from "./FAreaTable.vue?vue&type=script&lang=js"
export * from "./FAreaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c03461b",
  null
  
)

export default component.exports